import Swiper from 'swiper';

jQuery(function ($) {

const swiper = new Swiper('.swiper-container', {
  effect: "fade",
  loop: true,
  autoplay: {
    delay: 5000,
  },
  fadeEffect: {
    crossFade: true
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});

$(window).on('load scroll resize', function () {
  if (window.matchMedia('(min-width:769px)').matches) {
    const header = $('#header');
    const nav = $('#header #nav');
    const mvH = $('.home .mv').height();
    var scroll = $(window).scrollTop();
    if (scroll > mvH) {
      header.addClass('scrollin');
      nav.slideUp(500);
    } else {
      header.removeClass('scrollin');
      nav.slideDown(500);
    }
  }
});

});
